export const getSelectOptionFromDictionary = (item: { _id: string, name: string}) => ({ value: item._id, label: item.name });